import styled from "styled-components";
import { Link } from "react-router-dom";
import { colors, fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const CardWrapperLink = styled(Link)<{
  isLastPost?: boolean;
  shouldAddBorder?: boolean;
  cardWidth: string;
  cardHeight: string;
}>`
  display: grid;
  width: ${(props) => props.cardWidth};
  height: ${(props) => props.cardHeight};
  margin-right: ${(props) => (props.isLastPost ? "32px" : "20px")};
  background-color: ${colors.white};
  border: ${(props) => (props.shouldAddBorder ? `1.2px solid ${colors.black}` : "")};
  ${breakpoints.smDown} {
    margin-right: 16px;
  }
`;

export const CardImage = styled.img<{
  src: string | undefined;
  imageWidth: string;
  imageHeight: string;
  imagePadding: string;
  imageObjectFit: string;
  imageBackgroundColor?: string;
}>`
  width: ${(props) => props.imageWidth};
  height: ${(props) => props.imageHeight};
  object-fit: ${(props) => props.imageObjectFit};
  padding: ${(props) => props.imagePadding};
  background-color: ${(props) => props.imageBackgroundColor || "transparent"};
`;

export const CardBottomPanel = styled.div<{ shouldAddBorder?: boolean }>`
  width: 256px;
  height: auto;
  border: ${(props) => (props.shouldAddBorder ? `1.2px solid ${colors.black}` : "")};
  border-top-width: 0px;
  padding: 13px 16px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const GuidePostCategory = styled.label`
  font-family: ${fonts.fontBauMedium};
  font-size: 11px;
  color: ${colors.black};
  text-transform: uppercase;
  margin-bottom: 10px;
`;

export const PostTitle = styled.div`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 22px;
  line-height: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
`;

export const ReadingTime = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-size: 12px;
  line-height: 16px;
`;
